module.exports = {"id":"199569","name":"Erick Torres","rating":"71","photo":"./data/images/photos/3/199569.png","club":{"name":"U.N.A.M.","logo":"./data/images/clubs/U.N.A.M..png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ErickTorres0.json
// module id = 1280
// module chunks = 0